import { BaseApi } from "../../../../shared/api/base";

class InstamedApi extends BaseApi {
  constructor() {
    super({});
  }

  capture(url, paymentInfo) {
    return this.post(url, paymentInfo);
  }
}

export function useInstamedApi() {
  const api = new InstamedApi();

  return {
    capture: (url, paymentInfo) => api.capture(url, paymentInfo),
  };
}
